// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@rugby/XDL/types";
import { hexToRGB } from "@rugby/XDL/Utilities";

const color = {
    primary: {
        main: "#007AB8",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#506A71",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FAFAFA",
        backgroundContrast: "#363636",
        backgroundDisabled: "#F1F1F1",
        backgroundLight: "#F3F4F5",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#BBCACD",
        disabled: "#CCCCCC",
        ui1: "#869DA2",
        ui2: "#BBCACD",
        ui3: "#EAEFF0",
        brand3: "#6FA618",
        white: "#FFFFFF",
        black: {
            main: "#000000",
            dark: "#292F33",
        },
        toast: {
            light: "#424342",
            dark: "#292F33",
        },
        tertiary: {
            main: "#424342",
            contrast: "#FFFFFF",
        },
    },
    text: {
        main: "#424342",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#007AB8",
    },
    success: {
        main: "#00A65A",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#E4104E",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#FAAB19",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#00C3C9",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];

const footer = {
    main: hexToRGB("#292F33", 0.9),
    contrast: "#FFFFFF",
};

export { footer as footerColor };
export default color;
